import { ResponsiveLine } from "@nivo/line";
import { ResponsivePie } from "@nivo/pie";
import LineData from "./LineData";
import Piedata from "./PieData";

const DashboardGraphSection = () => {
  return (
    <div className="Graph_Section">
      <div className="Graph_Card_Line">
        <div className="Top_Box">
          <div className="Left">
            <h4>Total Companies</h4>
            <span>Total Revenue</span>
          </div>
          <div className="Right">
            <span>|</span>
            <div className="Box">
              <div className="Dot"></div>
              <small>Current Week</small>
            </div>
            <div className="Box">
              <div className="Dot"></div>
              <small>Previous Week</small>
            </div>
          </div>
        </div>
        <ResponsiveLine
          data={LineData}
          margin={{ top: 20, right: 50, bottom: 100, left: 60 }}
          xScale={{ type: "point" }}
          yScale={{
            type: "linear",
            min: "auto",
            max: "auto",
            stacked: true,
            reverse: false,
          }}
          yFormat=" >-.2f"
          curve="natural"
          axisTop={null}
          axisRight={null}
          axisBottom={{
            orient: "bottom",
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legendOffset: 36,
            legendPosition: "middle",
          }}
          axisLeft={{
            orient: "left",
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legendOffset: -40,
            legendPosition: "middle",
          }}
          enableGridX={false}
          enableGridY={true}
          lineWidth={5}
          enablePoints={false}
          pointSize={10}
          pointColor={{ theme: "background" }}
          pointBorderWidth={2}
          pointBorderColor={{ from: "serieColor" }}
          pointLabelYOffset={-12}
          enableCrosshair={false}
          useMesh={true}
        />
      </div>
      <div className="Graph_Card_Pie">
        <h2>Employee Composition</h2>
        <div className="Graph_Box">
          <ResponsivePie
            data={Piedata}
            margin={{ top: 18, right: 0, bottom: 10, left: 0 }}
            sortByValue={true}
            innerRadius={0.5}
            padAngle={0.7}
            cornerRadius={3}
            activeOuterRadiusOffset={8}
            colors={{ scheme: "nivo" }}
            borderWidth={1}
            borderColor={{
              from: "color",
              modifiers: [["darker", 0.2]],
            }}
            arcLinkLabelsSkipAngle={10}
            arcLinkLabelsTextOffset={0}
            arcLinkLabelsTextColor="#000000"
            arcLinkLabelsStraightLength={17}
            arcLinkLabelsThickness={2}
            arcLinkLabelsColor={{ from: "color" }}
            arcLabelsSkipAngle={10}
            arcLabelsTextColor={{
              from: "color",
              modifiers: [["darker", "2"]],
            }}
            defs={[
              {
                id: "dots",
                type: "patternDots",
                background: "inherit",
                color: "rgba(255, 255, 255, 0.3)",
                size: 4,
                padding: 1,
                stagger: true,
              },
              {
                id: "lines",
                type: "patternLines",
                background: "inherit",
                color: "rgba(255, 255, 255, 0.3)",
                rotation: -45,
                lineWidth: 6,
                spacing: 10,
              },
            ]}
            fill={[
              {
                match: {
                  id: "ruby",
                },
                id: "dots",
              },
              {
                match: {
                  id: "c",
                },
                id: "dots",
              },
              {
                match: {
                  id: "go",
                },
                id: "dots",
              },
              {
                match: {
                  id: "python",
                },
                id: "dots",
              },
              {
                match: {
                  id: "scala",
                },
                id: "lines",
              },
              {
                match: {
                  id: "lisp",
                },
                id: "lines",
              },
              {
                match: {
                  id: "elixir",
                },
                id: "lines",
              },
              {
                match: {
                  id: "javascript",
                },
                id: "lines",
              },
            ]}
            legends={[]}
          />
        </div>
        <span>856 employee total</span>
      </div>
    </div>
  );
};

export default DashboardGraphSection;
